import { getServerURL } from "../shared/sharedFunctions";
import companyService from "./companyService";
import userService from "./userService";

const FormService = () => {
	const pub = {};
	
	pub.phishing = async (formValues) => {
		let req = {
			method: "POST",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			body: JSON.stringify({
				companyId: companyService.selectedCompany.id,
				...formValues
			})
		};
		
		let response = await fetch(`${getServerURL()}/api/form/phishing`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} sending phishing form`);
		}
	};
	
	pub.insurance = async (formValues) => {
		let req = {
			method: "POST",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			body: JSON.stringify({
				companyId: companyService.selectedCompany.id,
				...formValues
			})
		};
		
		let response = await fetch(`${getServerURL()}/api/form/insurance`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} sending insurance form`);
		}
	};

	pub.additionalServices = async (formValues) => {
		let req = {
			method: "POST",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			body: JSON.stringify({
				companyId: companyService.selectedCompany.id,
				...formValues
			})
		};
		
		let response = await fetch(`${getServerURL()}/api/form/additionalservices`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} sending additional services form`);
		}
	};
	
	pub.penTesting = async (formValues) => {
		let req = {
			method: "POST",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			body: JSON.stringify({
				companyId: companyService.selectedCompany.id,
				...formValues
			})
		};
		
		let response = await fetch(`${getServerURL()}/api/form/pentesting`, req);
		if (response.status !== 200) {
			throw new Error(`response status ${response.status} sending insurance form`);
		}
	};
	
	return pub;
};

export default FormService();